export default "__VITE_ASSET__DQdIAEPK__"